<div class="prs-auth-modal-panel" data-testing-id="mfa-verification-modal">
  <div class="modal-header border-0 pb-0">
    <h2 class="visually-hidden" id="prs-auth-modal-mfa-title">{{ 'account.login.otp.heading' | translate }}</h2>
    <button
      type="button"
      class="btn-close ms-auto"
      [attr.title]="'dialog.close.text' | translate"
      [attr.aria-label]="'dialog.close.text' | translate"
      (click)="hide()"
    ></button>
  </div>
  <div class="modal-body pt-0">
    <ish-mfa-verification-form />
  </div>
</div>
